<template>
  <section class="dvs-card">
    <div class="dvs-section-head">
      <h1 class="dvs-section-title">Material de Recuperación</h1>
    </div>

    <div class="dvs-grid-2">
      <DVSField
        :model-value="localForm.venaKg"
        id="dvs-vena"
        label="Vena (Kg)"
        type="text"
        inputmode="decimal"
        min="0"
        step="0.01"
        max-digits="4"
        placeholder="0.00"
        :error="errors.venaKg"
        error-message="Ingresa un valor válido."
        @update:modelValue="
          (value) => {
            localForm.venaKg = value;
            notifyFieldChange('venaKg');
          }
        "
      />

      <DVSField
        :model-value="localForm.scrapKg"
        id="dvs-scrap"
        label="Scrap (Kg)"
        type="text"
        inputmode="decimal"
        min="0"
        step="0.01"
        max-digits="4"
        placeholder="0.00"
        :error="errors.scrapKg"
        error-message="Ingresa un valor válido."
        @update:modelValue="
          (value) => {
            localForm.scrapKg = value;
            notifyFieldChange('scrapKg');
          }
        "
      />
    </div>

    <DVSField
      v-model="localForm.comentarios"
      id="dvs-comentarios"
      label="Comentarios (Opcional)"
      type="textarea"
      maxlength="280"
      :show-counter="true"
      @update:modelValue="notifyFieldChange('comentarios')"
    />
  </section>
</template>

<script setup>
import { computed } from "vue";

import DVSField from "../components/DVSField.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:modelValue", "field-change"]);

const localForm = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

function notifyFieldChange(field) {
  emit("field-change", { field });
}
</script>
